var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { Step } from '@shared/claim/steps';
import { CURRENT_CLAIM_TYPE_LAYOUT_COLOR } from '@declaration/layout';
import TitleImageDescriptionLayout from '@declaration/components/TitleImageDescriptionLayout.vue';
import { quitClaimDeclarationCloseCallback } from '@declaration/helpers/layoutMetaCallback';
const claim = namespace('claim');
const settings = namespace('settings');
let RobberyPNOExit = class RobberyPNOExit extends Vue {
    constructor() {
        super(...arguments);
        this.illustration = require('@declaration/assets/images/documents/checklist.svg');
        this.isUpdatingClaim = false;
    }
    get selfCareSettings() {
        return this.setting('selfCareSettings');
    }
    async save() {
        this.isUpdatingClaim = true;
        await this.updateAndSaveClaim({ step: Step.RobberyPNOExit, claimPayload: {} });
        this.isUpdatingClaim = false;
    }
    get description() {
        var _a, _b, _c, _d;
        return this.$tc('robbery_PNO.description', undefined, {
            phoneNumber: (_d = (_c = (_b = (_a = this.selfCareSettings) === null || _a === void 0 ? void 0 : _a.declaration) === null || _b === void 0 ? void 0 : _b.advisorPhoneNumbers) === null || _c === void 0 ? void 0 : _c.france) !== null && _d !== void 0 ? _d : '01 XX XX XX XX',
        });
    }
};
__decorate([
    claim.Action('updateAndSaveClaim')
], RobberyPNOExit.prototype, "updateAndSaveClaim", void 0);
__decorate([
    settings.Getter('setting')
], RobberyPNOExit.prototype, "setting", void 0);
RobberyPNOExit = __decorate([
    Component({
        components: {
            TitleImageDescriptionLayout,
        },
        meta: {
            title: 'page.title.confirmation',
            color: CURRENT_CLAIM_TYPE_LAYOUT_COLOR,
            close: quitClaimDeclarationCloseCallback,
        },
    })
], RobberyPNOExit);
export default RobberyPNOExit;
